import { Component } from '@angular/core';
import { AuthService } from './common/services/authservice';

@Component({
    templateUrl: './sitemap.component.html',
    styleUrls: ['./sitemap.component.scss']
})
export class SiteMapComponent {

    name: string;
    assetString;
    companyString;

    constructor(private auth: AuthService) {
        this.name = this.auth.User.Name;
        this.assetString = this.auth.GetAssetString();
        this.companyString = this.auth.GetCompanyString();
    }
}